import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addTicketsToCurrentTicketReservationRequest = {};
var _addTicketsToCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _bulkUpdateTicketReservationTagsByFilterRequest = {};
var _bulkUpdateTicketReservationTagsByFilterResponse = {};
var _bulkUpdateTicketReservationTagsRequest = {};
var _bulkUpdateTicketReservationTagsResponse = {};
var _cancelTicketReservationRequest = {};
var _cancelTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _createCheckoutRequest = {};
var _createCheckoutResponse = {};
var _createTicketReservationRequest = {
    ticketReservation: '_ticketReservation',
};
var _createTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _deleteCurrentTicketReservationRequest = {};
var _deleteCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _deleteTicketReservationRequest = {};
var _deleteTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _getCurrentTicketReservationRequest = {};
var _getCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _getTicketReservationRequest = {};
var _getTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _removeTicketsFromCurrentTicketReservationRequest = {};
var _removeTicketsFromCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _ticketReservation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    expirationDate: 'google.protobuf.Timestamp',
};
var _updateCurrentTicketReservationRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    ticketReservation: '_ticketReservation',
};
var _updateCurrentTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
var _updateTicketReservationRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    ticketReservation: '_ticketReservation',
};
var _updateTicketReservationResponse = {
    ticketReservation: '_ticketReservation',
};
function resolveWixEventsTicketreservationsV1TicketReservationManagementUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/ticket-reservations',
                destPath: '/v1/ticket-reservations',
            },
            {
                srcPath: '/events/v1/bulk/ticket-reservations',
                destPath: '/v1/bulk/ticket-reservations',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEventsTicketreservationsV1CheckoutServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-ticket-reservations',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/ticket-reservations',
                destPath: '/v1/ticket-reservations',
            },
            {
                srcPath: '/events/v1/bulk/ticket-reservations',
                destPath: '/v1/bulk/ticket-reservations',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates an e-comm checkout from reservation id. */
export function createCheckout(payload) {
    var _a = serializer(_createCheckoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCheckoutResponse, {}).fromJSON;
    function __createCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.CheckoutService.CreateCheckout',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1CheckoutServiceUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}/checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCheckout.fromReq = fromReq;
    __createCheckout.__isAmbassador = true;
    return __createCheckout;
}
/**
 * Creates a ticket reservation.
 *
 * Reserves specified tickets for a limited time while a customer completes their purchase.
 * The reservation will have `PENDING` status and will automatically expire after the
 * event's configured reservation duration (typically 5-30 minutes) unless confirmed.
 */
export function createTicketReservation(payload) {
    var _a = serializer(_createTicketReservationRequest, { _ticketReservation: _ticketReservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __createTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.CreateTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTicketReservation.fromReq = fromReq;
    __createTicketReservation.__isAmbassador = true;
    return __createTicketReservation;
}
/** Retrieves a ticket reservation by ID. */
export function getTicketReservation(payload) {
    var _a = serializer(_getTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __getTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'GET',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.GetTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTicketReservation.fromReq = fromReq;
    __getTicketReservation.__isAmbassador = true;
    return __getTicketReservation;
}
/** Retrieves the current site visitor's TicketReservation. */
export function getCurrentTicketReservation(payload) {
    var _a = serializer(_getCurrentTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __getCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'GET',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.GetCurrentTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrentTicketReservation.fromReq = fromReq;
    __getCurrentTicketReservation.__isAmbassador = true;
    return __getCurrentTicketReservation;
}
/**
 * Updates a TicketReservation.
 *
 *
 * Each time the TicketReservation is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the TicketReservation.
 * This ensures you're working with the latest TicketReservation
 * and prevents unintended overwrites.
 */
export function updateTicketReservation(payload) {
    var _a = serializer(_updateTicketReservationRequest, { _ticketReservation: _ticketReservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __updateTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.UpdateTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservation.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTicketReservation.fromReq = fromReq;
    __updateTicketReservation.__isAmbassador = true;
    return __updateTicketReservation;
}
/**
 * Updates the current site visitor's TicketReservation.
 *
 * Each time the TicketReservation is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the TicketReservation.
 * This ensures you're working with the latest TicketReservation
 * and prevents unintended overwrites.
 */
export function updateCurrentTicketReservation(payload) {
    var _a = serializer(_updateCurrentTicketReservationRequest, { _ticketReservation: _ticketReservation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __updateCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.UpdateCurrentTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCurrentTicketReservation.fromReq = fromReq;
    __updateCurrentTicketReservation.__isAmbassador = true;
    return __updateCurrentTicketReservation;
}
/** Add tickets to the latest unexpired visitor's TicketReservation. Creates TicketReservation if current is not found; */
export function addTicketsToCurrentTicketReservation(payload) {
    var _a = serializer(_addTicketsToCurrentTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addTicketsToCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __addTicketsToCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.AddTicketsToCurrentTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addTicketsToCurrentTicketReservation.fromReq = fromReq;
    __addTicketsToCurrentTicketReservation.__isAmbassador = true;
    return __addTicketsToCurrentTicketReservation;
}
/** Remove tickets from the latest unexpired visitor's TicketReservation, */
export function removeTicketsFromCurrentTicketReservation(payload) {
    var _a = serializer(_removeTicketsFromCurrentTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeTicketsFromCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __removeTicketsFromCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.RemoveTicketsFromCurrentTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current/remove',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeTicketsFromCurrentTicketReservation.fromReq = fromReq;
    __removeTicketsFromCurrentTicketReservation.__isAmbassador = true;
    return __removeTicketsFromCurrentTicketReservation;
}
/**
 * Deletes a ticket reservation permanently.
 *
 * Completely removes the reservation and releases all reserved tickets back into the inventory to available inventory. This action can't be undone.
 *
 * Call [Cancel Ticket Reservation](https://dev.wix.com/docs/api-reference/business-solutions/events/ticket-reservations/cancel-ticket-reservation) if you want to change the reservation status while keeping the record.
 */
export function deleteTicketReservation(payload) {
    var _a = serializer(_deleteTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __deleteTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.DeleteTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTicketReservation.fromReq = fromReq;
    __deleteTicketReservation.__isAmbassador = true;
    return __deleteTicketReservation;
}
/**
 * Deletes a current visitor's TicketReservation.
 * Deleting a TicketReservation permanently removes them from the TicketReservation List.
 */
export function deleteCurrentTicketReservation(payload) {
    var _a = serializer(_deleteCurrentTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCurrentTicketReservationResponse, { _ticketReservation: _ticketReservation }).fromJSON;
    function __deleteCurrentTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.DeleteCurrentTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/current',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCurrentTicketReservation.fromReq = fromReq;
    __deleteCurrentTicketReservation.__isAmbassador = true;
    return __deleteCurrentTicketReservation;
}
/**
 * Updates tags on multiple ticket reservations.
 *
 * Allows adding or removing tags from multiple reservations in a single operation.
 * Specify reservation IDs and the tags to assign or unassign. If a tag appears
 * in both assign and unassign lists, it will be assigned.
 *
 * Use this for immediate tag updates on a known set of reservations.
 */
export function bulkUpdateTicketReservationTags(payload) {
    var _a = serializer(_bulkUpdateTicketReservationTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateTicketReservationTagsResponse, {}).fromJSON;
    function __bulkUpdateTicketReservationTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.BulkUpdateTicketReservationTags',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/bulk/ticket-reservations/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateTicketReservationTags.fromReq = fromReq;
    __bulkUpdateTicketReservationTags.__isAmbassador = true;
    return __bulkUpdateTicketReservationTags;
}
/**
 * Updates tags on multiple ticket reservations asynchronously using filters.
 *
 * Allows bulk tag updates on reservations matching specified criteria.
 * The operation runs asynchronously and returns a job ID for tracking progress.
 * An empty filter will update all reservations.
 *
 * If a tag appears in both assign and unassign lists, it will be assigned.
 * Use this for large-scale tag operations based on reservation properties.
 */
export function bulkUpdateTicketReservationTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateTicketReservationTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateTicketReservationTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateTicketReservationTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.BulkUpdateTicketReservationTagsByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/bulk/ticket-reservations/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateTicketReservationTagsByFilter.fromReq = fromReq;
    __bulkUpdateTicketReservationTagsByFilter.__isAmbassador = true;
    return __bulkUpdateTicketReservationTagsByFilter;
}
/**
 * Cancels an existing ticket reservation.
 *
 * Changes the reservation status to `CANCELED_MANUALLY` and releases the reserved
 * tickets back to available inventory. Once cancelled, a reservation cannot be
 * restored. Only `PENDING` and `CONFIRMED` reservations can be cancelled.
 */
export function cancelTicketReservation(payload) {
    var _a = serializer(_cancelTicketReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelTicketReservationResponse, {
        _ticketReservation: _ticketReservation,
    }).fromJSON;
    function __cancelTicketReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.ticket_reservation',
            method: 'POST',
            methodFqn: 'wix.events.ticketreservations.v1.TicketReservationManagement.CancelTicketReservation',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEventsTicketreservationsV1TicketReservationManagementUrl({
                protoPath: '/v1/ticket-reservations/{ticketReservationId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelTicketReservation.fromReq = fromReq;
    __cancelTicketReservation.__isAmbassador = true;
    return __cancelTicketReservation;
}
//# sourceMappingURL=http.impl.js.map